import { render, staticRenderFns } from "./all_DC_info_small.vue?vue&type=template&id=2487cb96&scoped=true"
import script from "./all_DC_info_small.vue?vue&type=script&lang=js"
export * from "./all_DC_info_small.vue?vue&type=script&lang=js"
import style0 from "./all_DC_info_small.vue?vue&type=style&index=0&id=2487cb96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2487cb96",
  null
  
)

export default component.exports